import {TSyncStatus} from ".";

interface IStatusObject {
    icon: string
    status: TSyncStatus
    title: string
}